import { render, staticRenderFns } from "./merchant-index.vue?vue&type=template&id=c8b0244e&scoped=true"
import script from "./merchant-index.vue?vue&type=script&lang=js"
export * from "./merchant-index.vue?vue&type=script&lang=js"
import style0 from "./merchant-index.vue?vue&type=style&index=0&id=c8b0244e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b0244e",
  null
  
)

export default component.exports